/** Footer copy in Arabic. Mirrors `../en/footer.js` key for key. */
import codeltdLogo from '@/assets/images/codeltd-logo.png'
import { CODELTD_URL, SITE_EMAIL } from '@/data/links'

import { ACTIONS } from './site'

export const FOOTER = {
  columns: [
    {
      title: 'المنتج',
      links: [
        { label: 'اللوحات', href: '/#panels' },
        { label: 'لماذا MeetNPlan', href: '/#why' },
        { label: 'الأسئلة الشائعة', href: '/#faq' },
        { label: 'دليل الاستخدام', href: '/guide' },
      ],
    },
    {
      title: 'الشركة',
      links: [
        { label: 'تواصل معنا', href: '/contact' },
        { label: 'التحديثات', href: '/updates' },
        { label: SITE_EMAIL, href: `mailto:${SITE_EMAIL}` },
        ACTIONS.signIn,
      ],
    },
    {
      title: 'قانوني',
      links: [
        { label: 'سياسة الخصوصية', href: '/privacy' },
        { label: 'شروط الخدمة', href: '/terms' },
        { label: 'سياسة ملفات تعريف الارتباط', href: '/cookies' },
      ],
    },
  ],
  bottomLinks: [
    { label: 'الخصوصية', href: '/privacy' },
    { label: 'الشروط', href: '/terms' },
    { label: 'ملفات الارتباط', href: '/cookies' },
  ],
  copyright: '© 2026 MeetNPlan',
  maker: {
    label: 'منتج من',
    name: 'Code LTD',
    logo: codeltdLogo,
    href: CODELTD_URL,
  },
  wordmark: 'MeetNPlan',
}
